const prefix = '/api';

const api = {
  getStudyList: `${prefix}/student/study/list`,
  getStudentOrderList: `${prefix}/student/parents/detail`,
  getOrderDetail: (studentOrderNo, orderIndex) => `${prefix}/front/student/score/${studentOrderNo}/${orderIndex}` // /{studentOrderNo}
  // getOrderDetail: (studentOrderNo, orderIndex) => `${prefix}/student/score/${studentOrderNo}/${orderIndex}` // /{studentOrderNo}
};

export default {
  ...api
};
